import { photoConstants } from '../constants';
import { saveParams, deleteParams, createParams } from './base.reducers';

const name = 'photos';

const initialState = {
	saveLoading: 0,
	saveSuccess: false,
	deleteLoading: 0,
	allLoading: 0,

	photos: [],
	photosById: {}
};

export default (state = initialState, payload) => {
	const { type, data } = payload;
	switch (type) {
		// Save and edit photos
		case photoConstants.SAVING_PHOTO_REQUEST:
			return {
				...state,
				saveSuccess: false,
				saveLoading: state.saveLoading + 1,
			};
		case photoConstants.SAVING_PHOTO_SUCCESS:
			const { form } = data;
			return {
				...saveParams({ name, state, form }),
				saveLoading: state.saveLoading - 1,
				saveSuccess: true
			};
		case photoConstants.SAVING_PHOTO_FAILURE:	
			return {
				...state,
				saveLoading: state.saveLoading - 1,
			};
		// Delete photo
		case photoConstants.DELETE_PHOTO_REQUEST:
			return {
				...state,
				deleteLoading: state.deleteLoading + 1,
			};
		case photoConstants.DELETE_PHOTO_SUCCESS:
			const id = data;
			return {
				...deleteParams({ name, state, id }),
				deleteLoading: state.deleteLoading - 1
			};
		case photoConstants.DELETE_PHOTO_FAILURE:	
			return {
				...state,
				deleteLoading: state.deleteLoading + 1,
			};
		// Load photos
		case photoConstants.LOAD_PHOTOS_REQUEST:
			return {
				...state,
				allLoading: state.allLoading + 1,
			};
		case photoConstants.LOAD_PHOTOS_SUCCESS:
			return {
				...createParams({ name, state, data: data.data }),
				allLoading: state.allLoading - 1
			};
		case photoConstants.LOAD_PHOTOS_FAILURE:	
			return {
				...state,
				allLoading: state.allLoading - 1,
			};
		default:
			return state;
	}
};


// WEBPACK FOOTER //
// ./src/redux/reducers/photo.reducers.js